import {
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import t from "@/lang/lang";
import { Button, buttonVariants } from "@/shared/components/ui/button";
import { LucideIcon, RefreshCw } from "lucide-react";
import type { VariantProps } from "class-variance-authority";
import { ComponentProps } from "react";

export function CommonDialogTrigger(
  props: {
    icon: LucideIcon;
    label: string;
  } & ComponentProps<"button"> &
    VariantProps<typeof buttonVariants> & {
      asChild?: boolean;
    },
) {
  const { label, ...buttonProps } = props;

  return (
    <DialogTrigger asChild>
      <Button {...buttonProps}>
        <props.icon className="size-4" />
        {label !== "" && <span>{label}</span>}
      </Button>
    </DialogTrigger>
  );
}

export function CommonDialogHeader({
  title,
  description,
}: {
  title?: string;
  description?: string;
}) {
  return (
    <DialogHeader>
      <DialogTitle>{title}</DialogTitle>
      <DialogDescription>{description}</DialogDescription>
    </DialogHeader>
  );
}

export function CommonDialogFooter({
  isLoading,
  onClickAction,
  actionLabel = t("Bestätigen"),
  destructive = false,
  disabled,
}: {
  isLoading: boolean;
  onClickAction: () => void;
  actionLabel?: string;
  destructive?: boolean;
  disabled?: boolean;
}) {
  return (
    <DialogFooter>
      <DialogClose asChild>
        <Button variant="outline">{t("Abbrechen")}</Button>
      </DialogClose>
      <Button
        onClick={onClickAction}
        disabled={isLoading || disabled}
        variant={destructive ? "destructive" : "default"}
      >
        {isLoading && <RefreshCw className="size-4 animate-spin" />}
        {actionLabel}
      </Button>
    </DialogFooter>
  );
}
